import ColumnFactory from '@/Factories/ColumnFactory';
import ComponentManager from '@/Management/ComponentManager';
import * as StringFormatter from '@/Utility/StringFormatter';

export default class SubstituteTextColumnFactory extends ColumnFactory {

    public static isPlainText = true;
    public static isJQueryElement = false;
    public floatingPrecision: number;

    constructor(params: any) {
        super(params);
        this.floatingPrecision = this.paramOrDefault(params.floatingPrecision, null);
    }

    public getValue(): string {
        let encoded = this.encodeHTML(this.raw || '-');
        let cleaned = this.stringCleaner(encoded, 150);

        return cleaned;
    }

    private stringCleaner(str: string, maxLength: number): string {
        if (str == null) {
            return str;
        }

        str = str.toString();

        if (str.indexOf("\n") > -1 || str.indexOf("\r") > -1) {
            str = str.replace(/\\n\\r/g, ' $#% ');
            str = str.replace(/\\r\\n/g, ' $#% ');
            str = str.replace(/\\n/g, ' $#% ');
            str = str.replace(/\\r/g, ' $#% ');

            while (str.indexOf('$#%  $#%') > -1) {
                str = str.replace(/\$#%[\s]+\$#%/g, '$#%');
            }

            str = str.trim();
            str = str.replace(/\$#%/g, '-');
        }

        if (maxLength > 0 && maxLength < str.length - 1) {
            str = str.substring(0, maxLength - 3);
            str = str + '...';
        }

        return str;
    }

    private encodeHTML(html: string): string {
        return StringFormatter.escapeHtml(html, true);
    }
}

ComponentManager.setFactory('SubstituteTextColumn', SubstituteTextColumnFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');